import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { VueSvgIconPlugin } from "@yzfe/vue3-svgicon";
import "@yzfe/svgicon/lib/svgicon.css";
import install from "./install";
import i18n from "./i18n";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import VCalendar from "v-calendar";
import "v-calendar/style.css";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_API_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};
export const db = initializeApp(firebaseConfig);
export const firestore = getFirestore();

function readCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function clearTransitCookie(name) {
  document.cookie = `${name}=; Domain=.asabenin.org; Path=/; Max-Age=0; Secure; SameSite=Lax`;
}

const transitToken = readCookie("asa_t");
const transitFirebaseToken = readCookie("asa_ft");

if (transitToken) {
  clearTransitCookie("asa_t");
  clearTransitCookie("asa_ft");

  store.dispatch("CREATE_TOKEN", transitToken);
  store.dispatch("CREATE_IS_AUTH", true);

  if (transitFirebaseToken) {
    signInWithCustomToken(getAuth(), transitFirebaseToken).catch(console.error);
  }
}

if (!store.getters.loginToken && process.env.NODE_ENV === "production") {
  window.location.replace("https://pv.asabenin.org/");
}

createApp(App)
  .use(i18n)
  .use(install)
  .use(VueSvgIconPlugin, { tagName: "icon" })
  .use(VCalendar, {})
  .use(store)
  .use(router)
  .mount("#app");
